import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ApplicationInitializationService } from '../services/application-initialization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,private AppInit: ApplicationInitializationService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(this.authService.geteInitiativeCampaignsData()== true){
        return true;
      }
      else{
      window.location.href =  this.AppInit.environmentConfig.REDIRECTION_URL_PAGE_NOT_FOUND;
      return false;
      }
  }
  
}
